import { Pipe, PipeTransform } from '@angular/core';

import { clienteCarteiraTipos } from '../cliente-carteira-tipo';

@Pipe({
    name: 'clienteCarteiraTipo'
})
export class ClienteCarteiraTipoPipe implements PipeTransform {
    transform(value: number): string {
        if (!value) {
            return '';
        }

        const index = clienteCarteiraTipos.findIndex(tipo => tipo.id === value);
        if (index > -1) {
            return clienteCarteiraTipos[index].nome;
        }
        return '';
    }
}
